import * as React from 'react';
import {Platform, ScrollView, StyleSheet, View} from 'react-native';
import BackSubheader from '../elements/BackSubheader';
import {withGlobalize, WithGlobalizeProps} from 'react-native-globalize';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import AccountStore from 'src/stores/AccountStore';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {AppDispatch} from 'src/redux/store';
import Localized from 'src/constants/AppStrings';
import Styles from 'src/components/Styles';
import ReferralDetailsIcon from 'src/components/img/svg/ReferralDetailsIcon';
import AVText from 'src/components/elements/AVText';
import {Referral} from 'src/types/Referral';
import ScreenContext from 'src/components/ScreenContext';
import ReferralActions from 'src/actions/ReferralActions';
import Logger from 'src/logging/Logger';
import CrashlyticsEvents from 'src/logging/Crashlytics';
import Events from 'src/logging/Events';
import {alertError} from '../helpers/AlertHelper';
import LoadingScreen from 'src/components/screens/LoadingScreen';
import Util from 'src/Util';
import ReferralSignUpDetailsIcon from 'src/components/img/svg/ReferralSignUpDetailsIcon';
import {getDescriber} from './descriptor/DescriptorType';
import {
  markSingleMessageAsRead,
  NotificationMessageParams,
} from 'src/redux/thunks/notificationThunks/messageRead';

type ReferralDetailScreenProps = WithGlobalizeProps & {
  referralId: string;
  selectedReferItem: Referral;
  markMessageAsRead(params: NotificationMessageParams): void;
};
type ReferralDetailScreenState = {
  referalDetails: Referral;
  referralSuccess: boolean;
};

class ReferralDetailsScreen extends React.Component<
  ReferralDetailScreenProps,
  ReferralDetailScreenState
> {
  static contextType = ScreenContext;
  declare context: React.ContextType<typeof ScreenContext>;

  constructor(props) {
    super(props);
    this.fetchReferralDetails = this.fetchReferralDetails.bind(this);
    this.state = {
      referalDetails: null,
      referralSuccess: false,
    };
  }

  componentDidMount() {
    this.props.markMessageAsRead({
      externalServiceId: this.props.selectedReferItem.externalServiceId,
      messageType: 'Referral',
      locationId: this.props.selectedReferItem.locationId,
    });
    this.fetchReferralDetails();
  }
  async fetchReferralDetails() {
    try {
      const referalDetails = await ReferralActions.getReferralDetails(
        this.props.referralId,
      );
      Logger.Log.LogAPIEvent(
        'PlatformAPI',
        'FetchReferralDetails',
        JSON.stringify({referralId: this.props.referralId}),
        JSON.stringify(referalDetails),
      );
      this.setState({
        referalDetails,
      });
    } catch (e) {
      const errMsg = e.message ? e.message : e.toString();
      CrashlyticsEvents.log(
        'Exception',
        'ReferralDetailsScreen:fetchReferralDetails',
        errMsg,
      );
      Events.Error.trackEvent(
        'Exception',
        'ReferralDetailsScreen:fetchReferralDetails',
        errMsg,
      );
      alertError(errMsg);
      Logger.Log.LogAPIEvent(
        'PlatformAPI',
        'fetchReferralDetails',
        JSON.stringify({referralId: this.props.referralId}),
        JSON.stringify(e),
      );
    }
  }
  getDateText() {
    const snackDate = Util.formatDate(
      this.props.selectedReferItem.dateCreated,
      'MMM DD, YYYY',
    );
    const snackTime = Util.formatDate(
      this.props.selectedReferItem.dateCreated,
      'hh:mm A',
    );
    return snackDate + ' at ' + snackTime;
  }
  renderDescription(isSender) {
    const {selectedReferItem} = this.props;
    const {Labels} = Localized;
    const prefix = isSender
      ? Labels.formatString(
          Labels.rewards_description_text_sender,
          Util.formatCurrency(
            this.props,
            selectedReferItem?.amount ?? 0,
            AccountStore.getCurrency(),
          ),
        )
      : Labels.formatString(
          Labels.rewards_description_text_receiver,
          Util.formatCurrency(
            this.props,
            selectedReferItem?.amount ?? 0,
            AccountStore.getCurrency(),
          ),
        );

    return `${prefix}`;
  }

  renderDescriptionHeaderTitle() {
    const {selectedReferItem} = this.props;
    const {Labels} = Localized;
    const formattedAmount = this.getFormattedAmount(selectedReferItem?.amount);
    const textPrefix = Labels.formatString(
      Labels.referral_invite_friends,
      formattedAmount,
      formattedAmount,
    );
    return `${textPrefix}`;
  }

  getFormattedAmount(amount) {
    const formatted = Util.formatCurrency(
      this.props,
      amount ?? 0,
      AccountStore.getCurrency(),
    );
    return formatted?.split('.')[0];
  }

  renderDescriptiontitle() {
    return this.renderDescriptionHeaderTitle();
  }

  render() {
    const {selectedReferItem} = this.props;
    const {referalDetails} = this.state;
    const isSender = selectedReferItem?.sender === AccountStore?.getAccountId();
    if (!referalDetails) {
      return <LoadingScreen />;
    }
    const referralHeaderColor =
      Platform.OS === 'web' ? Styles.white : Styles.tabBarBackgroundColor;

    return (
      <BackSubheader
        style={{backgroundColor: referralHeaderColor}}
        title={Localized.Labels.rewards_detail_header_name}
      >
        <ScrollView
          style={[
            styles.scrollView,
            {backgroundColor: getDescriber().referralDetailBgColorDescriptor()},
          ]}
        >
          <View style={styles.iconContainer}>
            {isSender ? (
              <ReferralDetailsIcon color={getDescriber().referralIconColor()} />
            ) : (
              <ReferralSignUpDetailsIcon
                color={getDescriber().referralIconColor()}
              />
            )}
          </View>
          <View style={styles.textContainer}>
            <AVText
              style={
                getDescriber().renderReferralStyleDescriptor()[
                  'referralHederText'
                ]
              }
            >
              {this.renderDescriptiontitle()}
            </AVText>
            <AVText
              style={
                getDescriber().renderReferralStyleDescriptor()[
                  'referralDescText'
                ]
              }
            >
              {this.getDateText()}
            </AVText>
          </View>
          <View style={styles.flexTextContainer}>
            <AVText
              style={[
                getDescriber().renderReferralStyleDescriptor()[
                  'referralDescText'
                ],
                styles.succText,
              ]}
            >
              {this.renderDescription(isSender)}
            </AVText>
          </View>
        </ScrollView>
      </BackSubheader>
    );
  }
}

const styles = StyleSheet.create({
  referralBtn: {
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  referralSuccErrView: {
    flexDirection: 'row',
    marginBottom: 10,
    borderRadius: 8,
    paddingVertical: 16,
    paddingHorizontal: 12,
  },

  scrollView: {
    flex: 1,
    padding: 20,
  },
  iconContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 10,
  },
  textContainer: {
    marginBottom: 15,
  },
  flexTextContainer: {
    flexDirection: 'row',
    marginBottom: 25,
  },
  flexRowContainer: {
    flexDirection: 'row',
  },
  flexLeft: {
    flex: 0.1,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  flexRight: {
    flex: 0.9,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  referralTextDesc: {
    fontWeight: '700',
    paddingRight: 5,
  },
  flexLeftWeb: {
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  succText: {
    flex: 1,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  markMessageAsRead: (params) => dispatch(markSingleMessageAsRead(params)),
});

export default compose(
  withForwardedNavigationParams<ReferralDetailScreenProps>(),
  withGlobalize,
  connect(null, mapDispatchToProps),
)(ReferralDetailsScreen);
